import React, { memo } from "react"
import { Link } from "gatsby"

/**
 * "What that has produced" — §6.4. Stats never sit in cards (§2.2): all three
 * reference sites use a thin accent rule, a large light numeral and a small
 * label, with no fill or border anywhere.
 *
 * The 2px signal rule above each item and the hairline separators between them
 * are pseudo-elements, not borders — acceptance criterion 6 requires the stat
 * items themselves to carry no background, border, border-radius or box-shadow.
 *
 * Deliberately not links: the footer already points at the Big Jerry's and
 * Nurtureful case studies, and stacking a second link to the same URL from one
 * page is the duplication the internal-linking rules warn against.
 */
/**
 * Three stats, not four. Centric Events was removed: events production is not
 * one of the eight ICPs, and "guaranteed margins" was the strongest word on the
 * page attached to the least relevant proof. Three ICP-matched results beat
 * four with one unmatched.
 *
 * Client names and metrics are attributed content and are not rewritten
 * (CONTENT-ARCHITECTURE §0).
 */
/**
 * `to` is the case study page for that client, or null where none exists.
 *
 * VERIFIED AGAINST THE BUILD, not assumed. Big Jerry's Fencing and Nurtureful
 * Psychology both resolve 200. EcoZohm has no case study PAGE — only a PDF
 * (src/files/Visiomate_EcoZohm_Case_Study.pdf) surfaced on /WhitepapereBooks —
 * so its stat stays unlinked rather than pointing somewhere that does not
 * exist. Do not add a `to` here without checking the route resolves.
 *
 * Client names and metrics are attributed content and are not rewritten
 * (CONTENT-ARCHITECTURE §0). The labels around them are ours and are not.
 */
const STATS = [
  {
    value: "40%",
    label: "faster from lead to installation",
    client: "Big Jerry's Fencing",
    to: "/caseStudies/projects/bigJerrysFencing/",
  },
  {
    value: "99%",
    label: "of quotes accurate first time",
    client: "EcoZohm",
    to: null,
  },
  {
    value: "50%",
    label: "less time on admin",
    client: "Nurtureful Psychology",
    to: "/caseStudies/projects/nurturefulPsychology/",
  },
]

const ProofBand = () => (
  <section className="hs-proof">
    <div className="hs-proof__inner">
      <span className="hs-proof__eyebrow">What that has produced</span>
      <h2 className="hs-proof__heading">Businesses like yours, and what changed</h2>
      <p className="hs-proof__lede">
        Each number below came from a business that had the problem you just
        read.
      </p>

      <div className="hs-proof__grid">
        {STATS.map((s, i) => {
          const body = (
            <>
              <p className="hs-proof__value">{s.value}</p>
              <p className="hs-proof__label">{s.label}</p>
              <p className="hs-proof__client">{s.client}</p>
            </>
          )
          // The whole stat is the link, not just the client name: the numeral
          // is what the reader is looking at, and a 12px name is a poor target.
          return (
            <div
              key={s.client}
              className="hs-proof__stat"
              data-reveal
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              {s.to ? (
                <Link
                  to={s.to}
                  className="hs-proof__link"
                  aria-label={`${s.value} ${s.label} — read the ${s.client} case study`}
                >
                  {body}
                </Link>
              ) : (
                body
              )}
            </div>
          )
        })}
      </div>
    </div>
  </section>
)

export default memo(ProofBand)
